import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DynamicContentModule } from '@woolworthsnz/dynamic-content';
import { RecipeBreadcrumbService, RecipeModule } from '@woolworthsnz/recipe';
import { BREADCRUMBS, StyleguideModule } from '@woolworthsnz/styleguide';
import { RecipeDetailsPage } from './pages/recipe-details/recipe-details.page';
import { RecipesCategoryPage } from './pages/recipes-category/recipes-category.page';
import { RecipesSearchPage } from './pages/recipes-search/recipes-search.page';
import { RecipesPage } from './pages/recipes/recipes.page';
import { RecipesRoutingModule } from './recipes.routing.module';

@NgModule({
	imports: [
		CommonModule,
		StyleguideModule.forRoot(),
		RecipesRoutingModule,
		RecipeModule,
		DynamicContentModule,
		RecipeDetailsPage,
		RecipesCategoryPage,
		RecipesPage,
		RecipesSearchPage,
	],
	providers: [
		{
			provide: BREADCRUMBS,
			useExisting: RecipeBreadcrumbService,
		},
	],
})
export class RecipesModule {}
